import { createSlice } from '@reduxjs/toolkit';

// جلب اللغة المخزنة محلياً أو استخدام الإنجليزية كافتراضي
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('sanad_language');
  if (savedLanguage) {
    return savedLanguage;
  }
  return 'en'; // الإنجليزية هي الافتراضية
};

const getInitialDirection = () => {
  const savedLanguage = localStorage.getItem('sanad_language');
  if (savedLanguage === 'ar') {
    return 'rtl';
  }
  return 'ltr';
};

const languageSlice = createSlice({
  name: 'language',
  initialState: {
    currentLanguage: getInitialLanguage(),
    direction: getInitialDirection(),
  },
  reducers: {
    toggleLanguage: (state) => {
      const newLanguage = state.currentLanguage === 'en' ? 'ar' : 'en';
      const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
      // تحديث الحالة
      state.currentLanguage = newLanguage;
      state.direction = newDirection;
      
      // حفظ في localStorage
      localStorage.setItem('sanad_language', newLanguage);
      
      // تحديث HTML document
      document.documentElement.dir = newDirection;
      document.documentElement.lang = newLanguage;
    },
    setLanguage: (state, action) => {
      const newLanguage = action.payload;
      const newDirection = newLanguage === 'ar' ? 'rtl' : 'ltr';
      
      // تحديث الحالة
      state.currentLanguage = newLanguage;
      state.direction = newDirection;
      
      // حفظ في localStorage
      localStorage.setItem('sanad_language', newLanguage);
      
      // تحديث HTML document
      document.documentElement.dir = newDirection;
      document.documentElement.lang = newLanguage;
    },
    initializeLanguage: (state) => {
      // تهيئة اللغة من localStorage
      const savedLanguage = localStorage.getItem('sanad_language') || 'en';
      const direction = savedLanguage === 'ar' ? 'rtl' : 'ltr';
      
      state.currentLanguage = savedLanguage;
      state.direction = direction;
      
      document.documentElement.dir = direction;
      document.documentElement.lang = savedLanguage;
    }
  },
});

export const { toggleLanguage, setLanguage, initializeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
// import { createSlice } from '@reduxjs/toolkit';

// const languageSlice = createSlice({
//   name: 'language',
//   initialState: {
//     currentLanguage: 'en', // الإنجليزية هي الافتراضية
//     direction: 'ltr',
//   },
//   reducers: {
//     toggleLanguage: (state) => {
//       state.currentLanguage = state.currentLanguage === 'en' ? 'ar' : 'en';
//       state.direction = state.currentLanguage === 'ar' ? 'rtl' : 'ltr';
//       document.documentElement.dir = state.direction;
//       document.documentElement.lang = state.currentLanguage;
//     },
//     setLanguage: (state, action) => {
//       state.currentLanguage = action.payload;
//       state.direction = action.payload === 'ar' ? 'rtl' : 'ltr';
//       document.documentElement.dir = state.direction;
//       document.documentElement.lang = state.currentLanguage;
//     },
//   },
// });

// export const { toggleLanguage, setLanguage } = languageSlice.actions;
// export default languageSlice.reducer;